import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { featuredInstoreOffers as orgModuleConfig } from 'org/configs/modules.config';
import orgConfig from 'org/configs/org.config';

const { instoreLabel } = orgConfig;

const defaultConfig = {
  defaults: {
    api: {
      offers: {
        params: {
          active: 1,
          type: 'instore',
        },
        options: {},
      },
      title: {
        params: {
          type: 'online',
          limit: 1,
          fields: ['assets.text'],
        },
        options: {},
      },
    },
    getViewAllLinkUrl: () => '',
    getViewAllLinkTitle: () => '',
    getStaticTitle: () => '',
    checkShouldUseCarousel: (isMobileMQ) => !isMobileMQ,
    shouldShowEducationalTile: false,
    carousel: {
      breakpoints: {
        l: {
          hasArrows: true,
          hasDots: false,
        },
      },
    },
    contentWrap: {
      ignoreWrap: true,
    },
  },
  is: {
    api: {
      offers: {
        params: {
          content_group_id: 35261,
        },
      },
      title: {
        params: {
          content_group_id: 35261,
        },
      },
    },
    checkShouldUseCarousel: () => false,
    contentWrap: {
      ignoreWrap: false,
    },
  },
  h: {
    api: {
      offers: {
        params: {
          content_group_id: 20575,
        },
      },
    },
    getStaticTitle: (earnType) => (
      <>
        Earn {earnType} when you shop <span className="mn_noWrap">{instoreLabel}</span><span className="mn_dot">.</span>
      </>
    ),
    getViewAllLinkUrl: (siteUrl) => `${siteUrl}/instore`,
    getViewAllLinkTitle: () => 'View all',
    shouldShowEducationalTile: true,
    contentWrap: {
      ignoreWrap: false, mobile: true, tablet: true, l: true, xl: true, xxl: false,
    },
    checkShouldUseCarousel: () => false,
  },
  me: {
    api: {
      offers: {
        params: {
          content_group_id: 35261,
        },
      },
    },
    checkShouldUseCarousel: () => true,
    shouldUseDesktopTileOnMobile: true,
    carousel: {
      hasCounter: true,
      hasDots: false,
      breakpoints: {
        l: {
          hasCounter: false,
        },
      },
    },
    contentWrap: {
      ignoreWrap: false,
    },
    getViewAllLinkUrl: (siteUrl) => `${siteUrl}/instore`,
    getViewAllLinkTitle: () => 'View all in-store offers',
    getStaticTitle: () => 'Featured in-store offers',
  },
};

export default mergeModuleConfigs(defaultConfig, orgModuleConfig);
